module.exports = __webpack_public_path__ + "img/mainSlide-2.25e48932.jpg";